export default __webpack_public_path__ + "static/media/InsureLeaguehd-rmbg.1dc32e60.png";